// removed by extract-text-webpack-plugin
module.exports = {"reg-form":"styles--reg-form--1MnlHGpl","regForm":"styles--reg-form--1MnlHGpl"};


//////////////////
// WEBPACK FOOTER
// ./src/App/events/Views/Detail/RegistrationCard/styles.css
// module id = 1358
// module chunks = 2